import Vue from 'vue';
import Router from 'vue-router';
import DashboardLayout from './../pages/Publisher/MainLayout.vue';
import users from '../pages/users.vue';
import login from '../pages/Login'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/login',
      component: DashboardLayout,
      children: [

        {
          path: 'users',
          name: 'Список всех пользователей',
          component: users
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component:login
    }
  ]
});
